<template>
  <!-- START MAIN CARD -->
  <div
    class="bg-white rounded-lg shadow hover:shadow-lg hover:cursor-pointer mb-6 pt-5"
  >

              <div class="flex flex-row-reverse">
              <BaseToggle
                v-model="published" 
                :height=4
                :width=8
                :name="this.survey.id"
                class="h-6 my-auto mr-5"
              />
              <div class="mt-1 ml-2 text-xs pr-3" :class="{'text-gray-400': !published, 'text-green-400': published, }">
                {{ published ? "Active" : "Paused" }}
              </div>
            </div>

    <router-link
      :to="{ name: 'survey-builder', params: { surveyid: survey.id } }"
      class="w-full cursor-pointer no-underline hover:no-underline"
    >
    <div class="h-36 flex flex-row justify-center items-center">
      <p class="px-4 pt-4 pb-6 text-gray-600 text-base font-bold my-auto">
        {{ name }}
      </p>
    </div>

    </router-link>

    <hr />

    <div class="flex flex-row justify-between p-4">
      <router-link
        class="hover:no-underline hover:text-gray-600 cursor-pointer font-semibold inline-block pb-1 px-2 uppercase rounded text-gray-600 bg-purple-200 uppercase"
        :to="{ path: '/results/' + survey.id }"
      >
      <span v-text="responseCount + ' responses'" class="text-xs"></span> 
      </router-link>

      <BaseDropDown
        v-on:clone-survey="$emit('clone-survey', survey.id)"
        v-on:confirm-delete="$emit('confirm-delete', survey.id)"
        v-bind:items="[
          {
            label: 'Edit flow',
            route: { path: '/builder/' + survey.id },
            icon: 'heroicons/outline/pencil-alt',
          },
          {
            label: 'Clone flow',
            event: 'clone-survey',
            args: survey.id,
            icon: 'heroicons/outline/duplicate',
          },
          {
            label: 'Delete flow',
            event: 'confirm-delete',
            args: survey.id,
            icon: 'heroicons/outline/x-circle',
          },
          {
            label: 'View responses',
            route: { path: '/results/' + survey.id },
            icon: 'heroicons/outline/chart-square-bar',
          },
          {
            label: 'Install Code',
            route: { path: '/settings/' + survey.id },
            icon: 'heroicons/outline/cog',
          },
        ]"
      >
        <template v-slot:button>
          <div class="items-center flex">
            <span
              class="mr-4 text-gray-400 hover:text-gray-500 hover:bg-gray-200 inline-flex items-center justify-center rounded"
            >
              <svg-icon
                icon="heroicons/outline/dots-horizontal"
                class="h-6 w-6 text-gray-600"
              ></svg-icon>
            </span>
          </div>
        </template>
      </BaseDropDown>
    </div>
  </div>
</template>

<script>
import Survey from "@/models/Survey";
import axios from "axios";

export default {
  components: { },
  data() {
    return {
      responseCount: 0,
    };
  },
  props: ["survey"],
  //components: { SvgImage },
  computed: {
    name() {
      return this.survey.name;
    },
    //Get the first image used in the survey
    previewImage() {
      return 'undraw/undraw_Post_re_mtr4';
      //return this.survey.steps[0].options[0].image;
    },
    published: {
      get() {
        return this.survey.published;
      },
      async set(value) {
        if (value !== this.survey.published) {
          await Survey.update({
            where: this.survey.id,
            data: {
              published: value,
            },
          });

          let post = await Survey.api().post("/api/survey/save", this.survey);

          if (post.response.status == 200) {

/*
            this.$store.dispatch("notification/add", {
              message:
                value == 1
                  ? "Campaign is launched!"
                  : "Campaign has been paused.",
            });
*/

          } else {
            this.$store.dispatch("notification/add", {
              message: post.response.data.error.message,
            });
          }



        }
      },
    },
  },
  methods: {
    async init() {
      var resp = await axios.get(`api/response/count/${this.survey.id}`);
      this.responseCount = resp.data;
      this.devlog("response: " + resp.data);
    },
    togglePublished(){
      console.log(this.survey.id + "~" + this.published)
    }
  },
  created() {
    this.init();
  },
};
</script>

<style></style>
